import { render } from "./changeDevicename.vue?vue&type=template&id=5c951736&scoped=true"
import script from "./changeDevicename.vue?vue&type=script&lang=js"
export * from "./changeDevicename.vue?vue&type=script&lang=js"

import "./changeDevicename.vue?vue&type=style&index=0&id=5c951736&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c951736"]])

export default __exports__